import { type FC } from 'react'
import NumberBox from 'Presentation/Components/Statistics/NumberBox'

interface Props {
	stat1: number | string | null
	stat2: number | string | null
	stat3: number | string | null
}

const StatisticZone: FC<Props> = ({ stat1, stat2, stat3 }) => {
	return (
		<div className="row mb-5 mb-xl-8">
			<div className="col-12 col-xl-4 mb-3 mb-xl-0">
				<NumberBox
					// actionTitle="View Report"
					toolTip="current-bill"
					unitTooltip="บาท"
					name="Statistics"
					title="ยอดที่อยู่ระหว่างการผลิต"
					value={(stat1 ?? 0).toLocaleString('th-TH', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})}
					unit={'บาท'}
					valueChangePercentage={1.3}
					hideTrend
				/>
			</div>
			<div className="col-12 col-xl-4 mb-3 mb-xl-0">
				<NumberBox
					// actionTitle="View Report"
					toolTip="on-processing"
					unitTooltip="บาท"
					name="Statistics"
					title="กำลังดำเนินการ"
					value={(stat2 ?? 0).toLocaleString('th-TH', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})}
					unit={'บาท'}
					valueChangePercentage={-1.3}
					hideTrend
				/>
			</div>
			<div className="col-12 col-xl-4 mb-3 mb-xl-0">
				<NumberBox
					// actionTitle="View Report"
					toolTip="last-bill"
					unitTooltip="บาท"
					name="Statistics"
					title="ชำระแล้ว"
					value={(stat3 ?? 0).toLocaleString('th-TH', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})}
					unit={'บาท'}
					valueChangePercentage={1.3}
					hideTrend
				/>
			</div>
		</div>
	)
}

export default StatisticZone
